// extracted by mini-css-extract-plugin
module.exports = {"modal_root":"ReorderPdf_modal_root__3FTD4","container":"ReorderPdf_container__2WRs9","dragable_item":"ReorderPdf_dragable_item__2unTJ"};